import React from "react";
import { Navigate } from "react-router-dom";

const Voids = (props) => {
  const [isLoading, setIsLoading] = React.useState(false);
  const loadingMessage = (
    <div className="container text-center">
      <div className="spinner-border spinner-border-lg" role="status">
        <span className="visually-hidden"></span>
      </div>
    </div>
  );
  const [data, setData] = React.useState({
    data: [{}],
  });
  const dataObj = {
    store_id: props.store,
    command: "voids",
    business_date: props.date,
  };
  const controller = new AbortController();
  const requestOptions = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(dataObj),
    signal: controller.signal,
  };
  React.useEffect(() => {
    setIsLoading(true);
    fetch(process.env.REACT_APP_ATAGLANCE_LAMBDA, requestOptions)
      .then((res) => res.json())
      .then((resJson) => {
        setData(resJson);
        setIsLoading(false);
      })
      .catch((error) => {
        console.log("Error: ", error);
      });
    return () => {
      controller.abort();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.date]);

  const tableRows = data.data.map((data, index) => {
    return (
      <tr key={index}>
        <td className="text-end">{data.order_num}</td>
        <td>{data.employee}</td>
        <td className="text-end">${data.subtotal ? data.subtotal.toFixed(2) : null}</td>
        <td>{data.reason}</td>
      </tr>
    );
  });

  const renderTable = (
    <div className="d-flex">
      <table className="table">
        <thead>
          <tr>
            <th className="text-end">#</th>
            <th>Employee</th>
            <th className="text-end">Amount</th>
            <th>Reason</th>
          </tr>
        </thead>
        <tbody>{tableRows}</tbody>
      </table>
    </div>
  );
  if (!props.auth) {
    return <Navigate replace to="/" />;
  }
  return isLoading ? loadingMessage : renderTable;
};

export default Voids;
